export default __webpack_public_path__ + "static/media/30.65f8d819.svg";